import React from "react";

import Header from "../../components/header";
import AdPage from "../../components/AdPage";

export default function TermsOfUse() {
  return (
    <>
      <Header />

      <AdPage />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/60 bg-blend-overlay backdrop-blur-md"></div>
      <div className="flex justify-center">
        <section className="my-8 px-10 max-w-[1116px]">
          <h1 className="text-center my-5 font-bold text-3xl underline">
            Privacy Policy
          </h1>
          <br />
          Effective Date: 2025-05-27
          <br />
          <br />
          <span className="font-bold">Introduction</span>
          <br />
          <br />
          Welcome to our website. This Privacy Policy explains how we collect,
          use, and protect your information when you visit and interact with our
          site. By using our website, you agree to the terms outlined in this
          policy.
          <br />
          <br />
          <span className="font-bold">Information Collection and Use</span>
          <br />
          <br />
          We may collect certain personally identifiable information (PII) such
          as your name, email address, or other details voluntarily provided
          when you contact us, subscribe to updates, or interact with our site.
          This information is only used to enhance your experience, respond to
          inquiries, or for communication purposes. We do not collect personal
          information without your knowledge.
          <br />
          <br />
          <span className="font-bold">Cookies</span>
          <br />
          <br />
          Our website uses cookies to improve user experience. Cookies are small
          data files stored on your device that help identify your browser and
          improve site functionality. You can disable cookies through your
          browser settings at any time. Disabling cookies may limit some
          features of our site.
          <br />
          <br />
          <span className="font-bold">Third-Party Services</span>
          <br />
          <br />
          We may use third-party services to enhance our site’s functionality,
          such as:
          <br />
          <br />
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            Google Analytics (to analyze sitetraffic)
          </span>
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            Google AdSense (to serve relevant advertisements)
          </span>
          <br />
          These services may collect certain data, and their own privacy
          policies apply. Please review their policies directly:
          <br />
          <br />
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            <a
              href="https://policies.google.com/privacy"
              className="text-blue-600 hover:underline"
            >
              Google Analytics Privacy Policy
            </a>
          </span>
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            <a
              href="https://policies.google.com/technologies/ads"
              className="text-blue-600 hover:underline"
            >
              Google AdSense Privacy Policy
            </a>
          </span>
          <br />
          <span className="font-bold">Data Security</span>
          <br />
          <br />
          We prioritize safeguarding your data but recognize that no method of
          transmission over the internet is completely secure. We strive to
          protect your information using commercially acceptable means but
          cannot guarantee absolute security.
          <br />
          <br />
          <span className="font-bold">Links to Other Websites</span>
          <br />
          <br />
          Our site may contain links to third-party websites. We are not
          responsible for the privacy practices or content of external sites. We
          recommend reviewing the privacy policies of any linked sites you
          visit.
          <br />
          <br />
          <span className="font-bold">Changes to This Privacy Policy</span>
          <br />
          <br />
          We may update this policy periodically. We encourage you to review it
          occasionally to stay informed about how we protect your data.
          Continued use of our website constitutes your acceptance of any
          changes.
          <br />
          <br />
          <span className="font-bold">Contact Us</span>
          <br />
          <br />
          If you have any questions or concerns about this Privacy Policy,
          please contact us at:{" "}
          <a
            href="mailto:KdNvS@example.com"
            className="text-blue-600 hover:underline"
          >
            info.PuffyGame@gmail.com
          </a>
          <br />
          <br />
        </section>
      </div>
    </>
  );
}
